(function() { window.GUID_c406fbc2_e12f_4571_a5b7_57c0fcb3cb65 = { getGuid: function() { return "c406fbc2-e12f-4571-a5b7-57c0fcb3cb65"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let StatSection;
        (function (StatSection) {
            StatSection[StatSection["Standings"] = 0] = "Standings";
            StatSection[StatSection["Charts"] = 1] = "Charts";
            StatSection[StatSection["History"] = 2] = "History";
            StatSection[StatSection["MVP"] = 3] = "MVP";
            StatSection[StatSection["Compare"] = 4] = "Compare";
            StatSection[StatSection["CSR"] = 5] = "CSR";
        })(StatSection = Enumeration.StatSection || (Enumeration.StatSection = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=StatSection.pre.js.map
